import React, {Component} from 'react';
import {connect} from "react-redux";
import './Campaign.css';
import {objectToFormData} from '../../utils/api'
import {updateBrand} from "../../actions/brandActions";
import Loading from "../Shared/Loading";
import {withRouter} from 'react-router-dom';
import SVG from 'react-inlinesvg';
import closeicon from '../../assets/close.svg';
import lock from '../../assets/lock-480x480.png';
import $ from 'jquery';

class BrandModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            brand: {
                vertical_options: [],
            },
            inputOptions: {
                verticals: [],
            },
            inputValues: {
                brand_name: '',
                hide_brand: false,
                verticals: []
            },
            redirect: false,
            vertical_error: ""
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleMultiCheckboxChange = this.handleMultiCheckboxChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    closeModal(e) {
        if (e.keyCode === 27) {
            this.props.toggleModal('brand', false)
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.closeModal);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.closeModal);
        let inputValues = Object.assign({}, this.state.inputValues);
        inputValues.brand_name = this.props.brand.name;
        inputValues.verticals = this.props.brand.verticals.map(v => v.id);
        inputValues.hide_brand = !!this.props.brand.hide_brand;
        let inputOptions = Object.assign({}, this.state.inputOptions);
        this.setState({
            brand: this.props.brand,
            inputValues: inputValues,
            inputOptions: inputOptions
        });

        this.handleSubmit.bind(this);
        $("html, body").animate({ scrollTop: 0 }, 300);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        let inputValues = Object.assign({}, this.state.inputValues);
        inputValues.brand_name = inputValues.brand_name.trim();
        const data = objectToFormData(inputValues);
        this.props.dispatch(updateBrand(this.props.brand.id, data)).then(res => {
            this.props.toggleModal('brand', false);
        }, err => {
            this.setState({
                errors: err.error_stack
            });
        });
        // this.props.dispatch(fetchSearchData());
    };

    handleTextChange(e, idx = false, prop = false) {
        const value = e.target.value;
        let inputValues = Object.assign({}, this.state.inputValues);
        if (idx !== false && prop !== false) {
            inputValues[e.target.name][idx][prop] = value;
        } else {
            inputValues[e.target.name] = value;
        }
        this.setState({inputValues});
    }

    handleMultiCheckboxChange(e) {
        const {name, checked} = e.target;
        const value = parseInt(e.target.value);

        let inputValues = this.state.inputValues;
        let arr = inputValues[name];
        let vertical_error = "";
        if (checked) {
            arr = [...arr, value];
        } else {
            arr = arr.filter(el => el !== value);
        }
        if(arr.length === 1 && arr.includes(60)){
            console.log("contains")
            vertical_error = "Error, please choose an additional vertical"
        }
        inputValues[name] = arr;
        this.setState({
            inputValues: inputValues,
            vertical_error: vertical_error
        });
    }
    handleCheckboxChange(e) {
        const {name, checked, value} = e.target;
        let inputValues = Object.assign({}, this.state.inputValues);

        inputValues[name] = checked ? 1 : 0;
        this.setState({inputValues});
    }

    render() {
        return (
            <div className="modal-overlay">
            <section className="modal modal--brand">
                <div className="modal-content">
                    <div className="closeBtn" onClick={() => this.props.toggleModal('brand', false)}>
                        <SVG src={closeicon}/>
                    </div>
                    <div className="modal-header">
                        <h1>Edit Brand</h1>
                    </div>
                    <form method="POST" onSubmit={this.handleSubmit}>
                        {this.state.errors &&
                        <ul className="error-list">
                            {this.state.errors.map((error, key) => (
                                <li key={key}>{error.msg}</li>
                            ))}
                        </ul>
                        }
                        <div className="form-group">
                            <div>
                                <label>Brand Name</label>
                                <input className="form-control" name="brand_name" defaultValue={this.state.inputValues.brand_name} onChange={this.handleTextChange} />
                            </div>
                            <div className="hide_brand_container">
                                <label><input type="checkbox" name="hide_brand" checked={this.state.inputValues.hide_brand} onChange={this.handleCheckboxChange}/><img id="icon-hidden-brand" src={lock} alt="brand is hidden"/>Hide brand</label>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Verticals  {this.state.vertical_error !== "" &&
                            <span className="vertical_warning">{this.state.vertical_error}</span>
                            }</label>

                            <ul className="verticals">
                                {this.state.brand.vertical_options.map((vertical, i) => {
                                    return <li key={i}><label><input type="checkbox" name="verticals"
                                                                     value={vertical.id}
                                                                     defaultChecked={this.state.inputValues.verticals.includes(vertical.id)}
                                                                     onChange={this.handleMultiCheckboxChange}/> {vertical.name}
                                    </label></li>
                                })}
                            </ul>
                        </div>
                        <div className="button-wrapper">
                            <button className="button button--transparent" type="button"
                                    onClick={() => this.props.toggleModal('brand', false)}>
                                Cancel
                            </button>
                            <button className="button button--black" type="submit">
                                Update
                            </button>
                        </div>
                    </form>
                    {this.props.loading && <div className="loading-mask">
                        <Loading/>
                    </div>}
                </div>
            </section>
            </div>
        );
    }

}

const mapStateToProps = state => ({
    loading: state.brand.loading,
});

export default withRouter(connect(mapStateToProps)(BrandModal));
